import { inject, Injectable } from '@angular/core';
import { EngagementForm } from '@interfaces';
import { FuncService } from "../../../../services";

@Injectable({
	providedIn: 'root'
})
export class EngagementEditorDialogService {

	private func = inject(FuncService);

	async getEngagementById(engagementId: number) {
		return await this.func.engagement.getEngagementById({ engagementId });
	}

	public async addEngagementDetails(engagement: EngagementForm, followUpId?: number) {
		const engagementId = await this.func.engagement.add({ engagement, followUpId });
		return engagementId;
	}

	public async updateEngagement(engagementId: number, engagement: EngagementForm) {
		const response = await this.func.engagement.update({ engagementId, engagement });
		return response;
	}

	public async closeEngagement(engagementId: number) {
		await this.func.engagement.closeEngagement({ engagementId });
	}
}